<template>
    <div id="account-search-results"
         class="search-results-list account-results-list invert">
        <h3>{{ l('MANAGE.RESULTS_TITLE') }} ({{ results.length }})</h3>

        <table class="dt-table">
            <thead>
                <tr>
                    <th>{{ l('MANAGE.NAME_COL_TITLE') }}</th>
                    <th>{{ l('MANAGE.POSTCODE_COL_TITLE') }}</th>
                    <th>{{ l('MANAGE.EMAIL_COL_TITLE') }}</th>
                    <th>{{ l('MANAGE.ACCOUNT_TYPE_COL_TITLE') }}</th>
                    <th class="dt-table__cell--narrow dt-table__cell--last desktop-only"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="account in currentPageAccounts"
                    :key="account.ID"
                    class="dt-table__row--clickable"
                    data-testid="account-result"
                    @click="viewAccount(account)">
                    <!-- Name cell (header on mobile) -->
                    <td>
                        <!-- Organisation name -->
                        <div v-if="account.organisation"
                             class="mb-05">
                            <i class="fa-regular fa-fw fa-building"></i>&nbsp;{{ account.organisation }}
                        </div>

                        <!-- Primary contact name -->
                        <i class="fa-solid fa-fw fa-user"></i>&nbsp;<ContactName v-if="account.primaryContact"
                                                                                 :contact="account.primaryContact" />
                    </td>

                    <!-- Postcode cell -->
                    <td :class="{'dt-table__cell--empty': !account.primaryAddress?.postcode}">
                        <i class="fa-regular fa-fw fa-location-dot mobile-only"></i>
                        {{ account.primaryAddress ? account.primaryAddress.postcode : '' }}
                    </td>

                    <!-- Email cell -->
                    <td :class="{'dt-table__cell--empty': !account.primaryContact?.email}">
                        <i class="fa-regular fa-fw fa-envelope mobile-only"></i>
                        {{ account.primaryContact ? account.primaryContact.email : '' }}
                    </td>

                    <!-- Account type cell -->
                    <td>
                        <span v-if="account.type === CustomerAccountType.PERSONAL">
                            <i class="fa-regular fa-fw fa-user"></i>
                            {{ l('CUSTOMER_DETAILS.TYPE_PERSONAL') }}
                        </span>
                        <span v-else-if="account.type === CustomerAccountType.BUSINESS">
                            <i class="fa-regular fa-fw fa-briefcase"></i>
                            {{ l('CUSTOMER_DETAILS.TYPE_BUSINESS') }}
                        </span>
                    </td>

                    <!-- Button cell -->
                    <td class="dt-table__cell--last dt-table__btn-cell desktop-only">
                        <button class="btn btn-lg btn-info dt-table__view-btn"
                                @click.stop="viewAccount(account)">
                            <i class="fa-solid fa-arrow-right"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import ContactName from '@/epos/vue/components/Customers/ContactName';
import CustomerAccountType from '@/lib/Customers/CustomerAccountType';
import { container } from '@/container';

export default {
    name: 'AccountSearchResults',

    components: { ContactName },

    props: {
        currentPage: {
            type: Number,
            required: true,
        },

        pageSize: {
            type: Number,
            required: true,
        },

        /**
         * @type {CustomerAccount[]}
         */
        results: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            /**
             * Account types are used in the template.
             */
            CustomerAccountType,
        };
    },

    computed: {
        currentPageAccounts() {
            return this.results.slice(
                (this.currentPage - 1) * this.pageSize,
                this.currentPage * this.pageSize,
            );
        },
    },

    methods: {
        /**
         * @param {CustomerAccount} account
         */
        viewAccount(account) {
            container.navigationService.viewAccountDetails(account.ID);
        },
    },
};
</script>
